import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from "./redux/store";
import { BrowserRouter } from 'react-router-dom';
import ThemeContextProvider from './context/themeContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { NetworkStatusProvider } from './context/NetworkStatusContext';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
    },
  },
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <ThemeContextProvider>
          <NetworkStatusProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </NetworkStatusProvider>
        </ThemeContextProvider>
      </QueryClientProvider>
    </Provider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
